import React from 'react';
import Logo from '../Logo';

const Hero = ({ onNavigateLogin }) => {
  return (
    <div className="px-8 pb-0 pt-8 relative bg-gradient-to-br from-[#055EFD] to-[#0449d4] overflow-hidden">
      <div className="absolute left-24 bottom-0 lg:top-0 opacity-40 w-[462px] h-[462px] lg:w-[600px] lg:h-[600px] z-0">
        <Logo width="100%" height="100%" logoFill="#6b21a8" mobile={true} />
      </div>
      <div className="w-[494.84px] h-[497.50px] absolute right-32 -bottom-[26rem] rotate-[8.60deg] opacity-30 bg-purple-800 rounded-full hidden lg:block"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="flex flex-col gap-6 justify-center pb-24 pt-8 order-1 lg:order-1">
            <div className="flex flex-col gap-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/10 rounded-full w-fit">
                <span className="text-white/80 text-xs font-medium font-['Inter']">Omnichannel AI Agent Platform</span>
              </div>
              <h1 className="!text-white text-4xl lg:text-5xl font-bold font-['Montserrat'] leading-tight">
                Deploy AI Agents That Work Like Real Employees
              </h1>
              <p className="!text-white/90 text-lg font-medium font-['Inter'] leading-relaxed">
                The only platform where your AI agent handles a caller, texts a payment link, emails a confirmation, and queries staff for real-time answers — all simultaneously in a single interaction.
              </p>
            </div>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => onNavigateLogin(true)}
                className="px-6 py-3 bg-white rounded flex justify-center items-center gap-2.5 hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="text-[#055EFD] text-sm font-bold font-['Inter']">Get Your API Key</span>
              </button>
              <button
                onClick={() => document.getElementById('demos')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-6 py-3 rounded border border-white flex justify-center items-center gap-2 hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="fa fa-play text-white text-xs"></i>
                <span className="text-white text-sm font-bold font-['Inter']">Watch Demos</span>
              </button>
            </div>
            <div className="flex flex-wrap gap-6 mt-2">
              <div className="flex items-center gap-2">
                <i className="fa fa-exchange text-cyan-300 text-sm"></i>
                <span className="text-white/80 text-xs font-medium">Simultaneous voice + SMS + email</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="fa fa-bolt text-yellow-300 text-sm"></i>
                <span className="text-white/80 text-xs font-medium">&lt;800ms voice latency</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="fa fa-line-chart text-green-300 text-sm"></i>
                <span className="text-white/80 text-xs font-medium">300 simultaneous calls</span>
              </div>
            </div>
          </div>

          <div className="relative flex justify-center lg:justify-end items-center order-2 lg:order-2 z-20 pb-12 lg:pb-16">
            <div className="w-full max-w-lg">
              <div className="bg-[#1e1e1e] rounded-lg overflow-hidden shadow-2xl border border-gray-700">
                <div className="flex items-center gap-2 px-4 py-3 bg-[#2d2d2d] border-b border-gray-700">
                  <div className="w-3 h-3 rounded-full bg-red-500"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                  <div className="w-3 h-3 rounded-full bg-green-500"></div>
                  <span className="text-gray-400 text-xs ml-2 font-mono">quickstart.py</span>
                </div>
                <pre className="p-4 text-sm font-mono overflow-x-auto text-gray-300" dangerouslySetInnerHTML={{ __html:
`<span style="color:#c084fc">import</span> requests

API_KEY = <span style="color:#4ade80">"your-api-key"</span>
BASE = <span style="color:#4ade80">"https://api.remote-assistant.io"</span>

<span style="color:#6b7280"># Create an assistant</span>
resp = requests.post(
    <span style="color:#4ade80">f"{BASE}/v1/assistants"</span>,
    headers={<span style="color:#4ade80">"X-API-Key"</span>: API_KEY},
    json={<span style="color:#4ade80">"business_name"</span>: <span style="color:#4ade80">"My Business"</span>}
)

<span style="color:#6b7280"># Your assistant is live</span>
phone = resp.json()[<span style="color:#4ade80">"phone_number"</span>]
<span style="color:#c084fc">print</span>(<span style="color:#4ade80">f"Call {phone} to test"</span>)`
                }} />
              </div>
            </div>
          </div>
          {/* Call Us banner */}
          <div className="col-span-1 lg:col-span-2 pb-12">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-5 flex flex-col sm:flex-row items-center gap-4 justify-between">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fa fa-phone text-white text-lg"></i>
                </div>
                <div>
                  <p className="!text-white text-sm font-bold font-['Montserrat']">Call us and experience it yourself</p>
                  <p className="!text-white/70 text-xs font-['Inter']">Our AI manages our own front desk operations — powered by the same platform you'll be building on.</p>
                </div>
              </div>
              <a href="tel:+18888649130" className="flex items-center gap-2 px-5 py-2.5 bg-white rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0">
                <i className="fa fa-phone text-[#055EFD] text-sm"></i>
                <span className="text-[#055EFD] text-sm font-bold font-['Inter'] whitespace-nowrap">1-888-864-9130</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
